/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Support_Internalquestions_Title1Inputs */

const en_settings_support_internalquestions_title1 = /** @type {(inputs: Settings_Support_Internalquestions_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal questions`)
};

/**
* | output |
* | --- |
* | "Internal questions" |
*
* @param {Settings_Support_Internalquestions_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_support_internalquestions_title1 = /** @type {((inputs?: Settings_Support_Internalquestions_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Internalquestions_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_support_internalquestions_title1(inputs)
});
export { settings_support_internalquestions_title1 as "settings_support_internalQuestions_title" }